export default __webpack_public_path__ + "static/media/No88.ddacecb2.png";